<template>
    <b-row v-if="requisicao">
        <b-col>
            <app-box titulo="Total requisição">{{
                requisicao.valor | currency
            }}</app-box>
        </b-col>
        <b-col>
            <app-box titulo="Saldo a ser rateado">{{
                requisicao.saldoASerRateado | currency
            }}</app-box>
        </b-col>
        <b-col>
            <app-box titulo="Total rateado">{{
                requisicao.totalRateado | currency
            }}</app-box>
        </b-col>
        <b-col>
            <app-box titulo="Saldo a ser comprometido">{{
                requisicao.saldoASerComprometido | currency
            }}</app-box>
        </b-col>
        <b-col>
            <app-box titulo="Total comprometido">{{
                requisicao.totalComprometido | currency
            }}</app-box>
        </b-col>
    </b-row>
</template>

<script>
export default {
    props: {
        requisicao: {
            type: Object
        }
    },

    computed: {
        // corTexto() {
        //     return this.percentualRateado < 100 ? 'danger' : 'primary'
        // },
        // corBox() {
        //     return this.percentualRateado < 100 ? 'danger' : 'primary'
        // }
    }
}
</script>